import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { IControlProps, MapProps } from '.';
import { InputText } from '../prime';
import styles from './index.module.scss';

interface IProps extends IControlProps<string> {
  storage?: IDataStorage;
  /** Largo máximo permitido */
  maxLength?: number;
  /** Verifica que el contenido sea un email válido */
  email?: boolean;

  /** Oculta los caracteres */
  isPassword?: boolean;

  /** class para el TextBox */
  inputClassName?: string;
  /** estilo para el TextBox */
  inputStyle?: React.CSSProperties;
}

interface IState extends IControlProps<string> {
  storage?: IDataStorage;
  maxLength?: number;
  email?: boolean;
  isPassword?: boolean;

  inputClassName?: string;
  inputStyle?: React.CSSProperties;

  /** Indica el mensaje de error si es que existe */
  validError?: string;
}

class Index extends React.Component<IProps, IState> {
  state: IState = {};
  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => this.change(this.state.value));
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.maxLength !== s?.maxLength) res.maxLength = p.maxLength;
    if (p?.email !== s?.email) res.email = p.email;
    if (p?.isPassword !== s?.isPassword) res.isPassword = p.isPassword;
    if (p?.inputClassName !== s?.inputClassName) res.inputClassName = p.inputClassName;
    if (p?.inputStyle !== s?.inputStyle) res.inputStyle = p.inputStyle;
    return MapProps(res, p, s);
  }

  render() {
    const { validError } = this.state;
    
    return (
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
        {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
        <div className={`${styles.addons} p-inputgroup`}>
          {this.state.icon &&
            <span className={`p-inputgroup-addon`}>
              <i className={this.state.icon} />
            </span>
          }
          {this.state.required && 
            <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
              <i className="pi pi-exclamation-circle" />
            </span>
          }
          <InputText 
            defaultValue={this.state.value}
            value={this.state.value}
            placeholder={this.state.placeholder}
            readOnly={this.state.disabled}
            maxLength={this.state.maxLength}
            type={!!this.state.isPassword ? 'password' : 'text'}
            tooltip={validError}
            tooltipOptions={{ position: 'bottom' }}
            onChange={e => !this.state.disabled && this.change((e.target as any).value)}
            onBlur={e => !this.state.disabled && this.change((e.target as any).value)}
            className={`w-100 p-inputtext ${styles.ctrl} ${this.state.inputClassName ?? ''} ${validError && 'p-error'}`}
            style={this.state.inputStyle}
          />
        </div>
        {validError && <span className={styles.errordesc}>{validError}</span>}
      </div>
    );
  }
  
  change = (value?: string) : string | undefined => {
    const { onChange, validate, isValid } = this.props;

    let error = this.validate(value);
    if (validate) error = validate(value);
    if (isValid) isValid(!error, error);
    
    this.setState({ validError: error });

    if (onChange) onChange(value, error);

    return error;
  }

  private validate = (value?: string) : string | undefined => {
    const { required, email } = this.state;

    if (required && (value?.length ?? 0) < 1) return 'campo requerido';
    if (value && email && !(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(`${value}`))) return "formato de email inválido";

    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
